import React, { useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import { Language } from "@components/General/LanguageSelector/languageSelector.component";
import { getLabel } from "@components/General/LanguageSelector/partials/label.component";

import "./dropdown.scss";
import { DropdownLanguageItem } from "./drownDownLanguageItem.component";

type Props = {
    variant?: string;
    languages: Language[];
    current: string;
};

const LanguageDropDownSelector = ({
    current,
    languages = [],
    variant,
}: Props) => {
    const [open, setOpen] = useState(false);

    const currentLanguageObject = languages.find(
        language => language.languageCode === current,
    );
    const currentLabel = current?.toUpperCase() || "";

    return (
        <Dropdown
            className="language-selector__dropdown"
            isOpen={open}
            toggle={() => setOpen(!open)}
        >
            <DropdownToggle caret>
                {!currentLanguageObject
                    ? currentLabel
                    : getLabel(currentLanguageObject!, variant)}
            </DropdownToggle>
            <DropdownMenu right={true}>
                {languages.map(language => (
                    <DropdownLanguageItem
                        key={language.languageCode}
                        language={language}
                        isDisabled={language.languageCode === current}
                        variant={variant}
                    />
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default LanguageDropDownSelector;
